import React, { useState } from 'react';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { Button, Field, TextOutput } from 'Components/Core';
import { ISelectOption } from 'Components/Core/Dropdown/types';
import { useDispatch, useSelector } from 'react-redux';
import className from 'classnames';
import { ListDropdown } from 'Components/List';
import { actions } from 'Data/ReduxViewModels/Ags/Project';

const AgsExportConfiguration: React.FC = () => {
  const dispatch = useDispatch();
  const agsProjectExport = useSelector((state) => state.agsProjectExport);
  const busyState = useSelector((state) => state.agsProjectExport.status?.busyState);

  const [testConditionsEditable, setTestConditionsEditable] = useState(false);

  const [selectedConfiguration, setSelectedConfiguration] = useState<ISelectOption | null>(
    agsProjectExport?.projectDetails?.agsExportConfigurationId
      ? {
          value: agsProjectExport.projectDetails.agsExportConfigurationId,
          label: agsProjectExport.projectDetails.agsExportConfigurationName ?? '',
        }
      : null
  );

  const dropDownOnChange = (evt: any) => {
    var selectedOption = evt.data.value;
    setSelectedConfiguration(selectedOption && { value: selectedOption.value, label: selectedOption.label });
    dispatch(
      actions.setAgsExportConfiguration({
        projectId: agsProjectExport.projectId,
        configurationId: selectedOption?.value,
      })
    );
  };

  return (
    <PageSection id="AgsExportConfiguration" heading="AGS Export Configuration">
      <ListFieldSection>
        <Field
          input={<ListDropdown />}
          label="Selected Configuration"
          endpoint="list.ags.exportConfigurations"
          disabled={!testConditionsEditable || busyState}
          value={selectedConfiguration}
          onChange={dropDownOnChange}
          visible={testConditionsEditable}
        />
        <Field
          input={<TextOutput />}
          label="Selected Configuration"
          value={selectedConfiguration?.label}
          visible={!testConditionsEditable}
        />
        <div className={className('Field', 'Field-Bottom-Vertical')}>
          <span>
            <Button
              onClick={() => {
                setTestConditionsEditable(true);
              }}
              visible={!testConditionsEditable}
            >
              Change
            </Button>
          </span>
        </div>
        <Field
          input={<TextOutput />}
          label="Configuration from the Laboratory"
          value={agsProjectExport.projectDetails.laboratoryMappedAgsExportConfigurationName}
          visible={!selectedConfiguration}
        />
      </ListFieldSection>
    </PageSection>
  );
};

export default AgsExportConfiguration;
